export default __webpack_public_path__ + "static/travel-f53d060afcf0575af38116ce2c0c319e.mp4";